import { Component, EventEmitter, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as _ from 'lodash';

import { columns } from '../../receiver-search/columns';

import { BaseConfigureExportModalComponent } from '../_base-configure-export-modal.component';
import { ReceiverSearchComponent } from '../../receiver-search/receiver-search.component';
import {ProductPanelComponent} from '../../../../../product-panel/product-panel.component';
import { Product } from '../../../../my-products.interface';


@Component({
  moduleId: module.id,
  selector: 'configure-receiver-export-modal',
  templateUrl: 'configure-receiver-export-modal.component.html',
  styleUrls: [
    '../configure-export-modal.component.scss',
    'configure-receiver-export-modal.component.scss'
  ],
})
export class ConfigureReceiverExportModalComponent extends BaseConfigureExportModalComponent {
  recieverSortingColumns: any = columns;
  status: string = 'published';

  @Input() products: Array<Product> = [];

  @ViewChild(ReceiverSearchComponent, {static: false})
  receiverSearch: ReceiverSearchComponent | void;

  /*******************************************
   * COMPONENT GETTERS
   *******************************************/

  get selectedReceivers(): Array<any> {
    return _.get(this, 'receiverSearch.selectedRows', []);
  }

  get canContinue(): boolean {
    return _.size(this.selectedPrices) > 0 && _.size(this.selectedReceivers) > 0;
  }


  /*******************************************
   * COMPONENT HANDLERS
   *******************************************/

  onShow(event: any) {
    if (this.receiverSearch) {
      this.receiverSearch.init();
    }
    super.onShow(event);
  }

  onHide(event: any) {
    if (this.receiverSearch) {
      this.receiverSearch.reset();
    }
    super.onHide(event);
  }

  /*******************************************
  * COMPONENT PROTECTED
  *******************************************/

  protected getConfigurationData(): any {
    return _.assign(super.getConfigurationData(), {
      receivers: _.map(this.selectedReceivers, '_id'),
    });
  }
}
